import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import classNames from 'classnames';

import { delayPayment } from '../payment/paymentActions.js';
import Page from '../../page.jsx';
import partnerPropTypes from '../../partnerPropTypes';
import paymentPropTypes from '../../paymentPropTypes.js';
import { inSevenDays, formatDate } from '../../getDeadline.js';
import { trackEvent } from '../../../services/trackingService';

class HandleMissingItemPage extends PureComponent {
    componentDidMount() {
        trackEvent(
            'trade.buyer-does-not-approve-item.item-not-received',
            'start'
        );
    }

    render() {
        const { payment, partner, handleClickDelayPayment } = this.props;

        const sevenDays = inSevenDays();
        const deadlineDate = new Date(payment.data.automaticApprove);
        const shouldDelay = sevenDays > deadlineDate;
        const newDeadline = shouldDelay ? sevenDays : deadlineDate;

        const btnClass = classNames('primary fullwidth', {
            inprogress: payment.loading,
        });

        const allowedDelaymentDate = new Date(
            Date.now() + (deadlineDate - sevenDays)
        );

        return (
            <Page heading="Utsett betalingen">
                <div>
                    <p>
                        Skal vi utsette betalingen slik at {partner.name} ikke
                        får pengene før du har mottatt varen?
                    </p>

                    <p className="r-pbl">
                        Du kan utsette betalingen med 7 dager. Pengene vil bli
                        automatisk overført til selger
                        <span className="strong">
                            {' '}
                            {formatDate(newDeadline)}
                        </span>.
                    </p>

                    <div className="r-phl">
                        <button
                            onClick={handleClickDelayPayment}
                            disabled={payment.loading || !shouldDelay}
                            className={btnClass}
                        >
                            Ja, utsett betaling
                        </button>
                    </div>

                    <div className="centerify">
                        {!shouldDelay && (
                            <p className="smalltext">
                                Betalingen kan ikke utsettes før{' '}
                                <strong>
                                    {formatDate(allowedDelaymentDate)}
                                </strong>.
                            </p>
                        )}

                        <div className="r-ptl">
                            <Link to="/samtale">Avbryt</Link>
                        </div>
                    </div>
                </div>
            </Page>
        );
    }
}

HandleMissingItemPage.propTypes = {
    itemId: PropTypes.string.isRequired,
    itemType: PropTypes.string.isRequired,
    partner: partnerPropTypes.isRequired,
    payment: paymentPropTypes.isRequired,
    handleClickDelayPayment: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        itemId: state.safeTrade.itemId,
        itemType: state.safeTrade.itemType,
        partner: state.partner,
        payment: state.payment,
    };
}

const mapDispatchToProps = { handleClickDelayPayment: delayPayment };

function mergeProps(stateProps, dispatchProps, ownProps) {
    const { itemType, itemId, partner } = stateProps;

    return {
        ...ownProps,
        ...stateProps,
        handleClickDelayPayment: () =>
            dispatchProps.handleClickDelayPayment({
                itemType,
                itemId,
                partnerId: partner.id,
            }),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
    HandleMissingItemPage
);



// WEBPACK FOOTER //
// ./safeTrade/buyer/resolution/handleMissingItemPage.jsx